import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useField, useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import {
  NOTIFICATION_FILE_UPLOAD,
  NOTIFICATION_FILE_UPLOADED_WITH_ERRORS,
} from '../../../../constants/notification'
import {
  getFormNotificationFilesIsUploading,
  getFormNotificationFilesWithErrors,
} from '../../../../utils/notification'
import {
  FORM_FIELD_NAME_FILES_UPLOADING,
  FORM_FIELD_NAME_FILES_WITH_ERRORS,
} from '../../Form.constants'

export function useFormFilesValidationErrorsNotification({
  files: { filesError, filesUploading } = EMPTY_OBJECT,
  formikContext,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const useHandlerFormikContext = !formikContext ? useFormikContext : undefined

  const { errors } = useHandlerFormikContext?.() || formikContext

  /* necessary for correct form validation and prevent submission
    while files is uploading or files have errors */
  useField({
    name: FORM_FIELD_NAME_FILES_UPLOADING,
    validate: () =>
      filesUploading?.length > 0 ? FORM_FIELD_NAME_FILES_UPLOADING : undefined,
  })

  useField({
    name: FORM_FIELD_NAME_FILES_WITH_ERRORS,
    validate: () =>
      filesError?.length > 0 ? FORM_FIELD_NAME_FILES_WITH_ERRORS : undefined,
  })

  useEffect(() => {
    if (errors[FORM_FIELD_NAME_FILES_UPLOADING]) {
      onSetNotification(getFormNotificationFilesIsUploading(t))
    } else {
      onRemoveNotification(NOTIFICATION_FILE_UPLOAD)
    }

    if (errors[FORM_FIELD_NAME_FILES_WITH_ERRORS]) {
      onSetNotification(getFormNotificationFilesWithErrors(t))
    } else {
      onRemoveNotification(NOTIFICATION_FILE_UPLOADED_WITH_ERRORS)
    }
  }, [errors])
}
